import { Grid } from '@mui/material'
import React from 'react'

import { MUIExternalLink } from 'components/common/MUIExternalLink'
import Icon from 'components/Icon'
import { GREMLIN_COM_DOCS_LINKS } from 'constants/external-urls-gremlin-docs'
import { muiTheme } from 'mui-theme'

export const DrawerLinkToReleaseNotes: React.FC = () => {
  return (
    <Grid item xs={12}>
      <MUIExternalLink
        href={GREMLIN_COM_DOCS_LINKS.RELEASE_NOTES_GENERAL}
        sx={{
          alignItems: 'center',
          color: 'inherit',
          display: 'flex',
          width: '100%',
          '&:hover, &:focus': { color: muiTheme.palette.darkModePrimary.main }
        }}
        underline="none"
      >
        <Icon
          css={{ marginRight: muiTheme.spacing(1) }}
          icon="solidTowerBroadcast"
        />
        What's new?
        <Icon
          css={{
            fontSize: muiTheme.typography.body2.fontSize,
            marginLeft: 'auto' // forces to the right
          }}
          icon="arrowUpRightFromSquare"
        />
      </MUIExternalLink>
    </Grid>
  )
}
